import React from "react";
import { IconType } from "react-icons";

export interface IconProps {
    as: IconType;
    width?: string;
    height?: string;
    color?: string;
    style?: React.CSSProperties;
    [key: string]: any;
}

const Icon: React.FC<IconProps> = ({ as: IconComponent, width, height, color, style, ...rest }) => {
    const iconStyle: React.CSSProperties = {
        display: "inline-block",
        verticalAlign: "middle",
        width: width || "1em",
        height: height || "1em",
        color: color,
        ...style,
    };

    // Create the icon element with proper typing
    const IconElement = IconComponent as React.ComponentType<any>;

    return <IconElement style={iconStyle} {...rest} />;
};

export default Icon;